var _circle, _path, _rect, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataExports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 70,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.798 52.25-4.528-1.145M37.163 61.604l-1.98 1.05M42.647 45.179l-.994-2.032",
    stroke: "#7E7E7E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.022,
    y: 39.048,
    width: 45.225,
    height: 58.729,
    rx: 5.839,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.29 40.423h19.588l17.287.009a3.235 3.235 0 0 1 3.233 3.235V79.61h-4.51v10.306h-5.182l5.977 7.006H54.29a3.235 3.235 0 0 1-3.235-3.235V43.658a3.235 3.235 0 0 1 3.235-3.235zm37.922 58.292H54.29a5.027 5.027 0 0 1-5.027-5.027V43.658a5.027 5.027 0 0 1 5.027-5.027h19.588l17.287.009a5.027 5.027 0 0 1 5.025 5.027V79.61h2.878v10.306h4.952l-9.543 11.452-2.265-2.654z",
    fill: "#73767D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.757 60.543h-5.349M85.757 69.617h-5.349M85.757 78.691h-5.349",
    stroke: "#73767D",
    strokeWidth: 1.641,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.682 52.034a2.73 2.73 0 0 0-2.73 2.73V82.06a2.73 2.73 0 0 0 2.73 2.73h27.297a2.73 2.73 0 0 0 2.73-2.73V54.763a2.73 2.73 0 0 0-2.73-2.73H45.682zm6.165 8.442 5.487 8.231-6.11 9.428h3.79l4.141-6.934 4.316 6.934h3.965l-6.335-9.353 5.388-8.306h-3.617l-3.592 6.036-3.642-6.036h-3.79z",
    fill: "#31B59F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.135 107.434a1.096 1.096 0 0 1 1.944 0l3.897 7.463a.55.55 0 0 0 .232.232l7.465 3.899c.785.41.785 1.534 0 1.943l-7.465 3.896a.55.55 0 0 0-.232.232l-3.897 7.466a1.096 1.096 0 0 1-1.944 0l-3.892-7.466a.545.545 0 0 0-.232-.232l-7.47-3.896a1.096 1.096 0 0 1 0-1.943l7.47-3.899a.55.55 0 0 0 .232-.232l3.892-7.463z",
    fill: "#EFEFF0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.451 15.556a.824.824 0 0 1 1.461 0l1.814 3.473a.41.41 0 0 0 .175.174l3.475 1.815a.824.824 0 0 1 0 1.462l-3.475 1.813a.412.412 0 0 0-.175.174l-1.814 3.475a.824.824 0 0 1-1.461 0l-1.811-3.474a.41.41 0 0 0-.175-.175l-3.477-1.813a.824.824 0 0 1 0-1.462l3.477-1.815a.411.411 0 0 0 .175-.174l1.811-3.473z",
    fill: "#EEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataExports);
export default __webpack_public_path__ + "static/media/data-exports.733532a294e1d097f222fa1a9a172bfe.svg";
export { ForwardRef as ReactComponent };